/**
 * Hooks da aba /auditoria — TanStack Query sobre o datasource `auditoria`.
 */

import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { useDataSources } from '@/services/datasources';
import type { AtorDaAuditoria, AuditCursor, AuditFilter, AuditPage } from '@/services/datasources/auditoria';

/**
 * Trilha paginada: cada página parte da última linha da anterior (cursor do
 * servidor). Os filtros vão inteiros na chave — mudar um filtro recomeça da 1ª página.
 */
export function useAuditLog(filter: AuditFilter) {
  const { auditoria } = useDataSources();
  return useInfiniteQuery<AuditPage, Error, AuditPage[], (string | AuditFilter)[], AuditCursor | null>({
    queryKey: ['audit-log', filter],
    initialPageParam: null,
    queryFn: ({ pageParam }) => auditoria.listEntries(filter, pageParam ? { after: pageParam } : undefined),
    getNextPageParam: (ultima) => ultima.next,
    select: (data) => data.pages,
  });
}

/** Pessoas com conta vinculada — opções do filtro de Ator, independentes da página. */
export function useAtoresDaAuditoria() {
  const { auditoria } = useDataSources();
  return useQuery<AtorDaAuditoria[], Error>({
    queryKey: ['audit-log-atores'],
    staleTime: 5 * 60 * 1000,
    queryFn: () => auditoria.listAtores(),
  });
}
